App.SmChosenComponent = Em.Component.extend
  classNames: [ 'sm-chosen' ]
  classNameBindings: ['isLoading']

  searchEnabled: true
  insertEnabled: true
  singular:      false
  isLoading:     false

  content: Em.A([])

  labelPath: ''
  labelTranslation: null

  canAddNewElement: (->
    return true unless @get('singular')

    @get('content.length') < 1
  ).property('singular', 'content.length')

  actions:
    sendOriginalQuery: ->
      @sendAction('onQuery', arguments...)
      false

    removeItem: (item) ->
      if @get('onRemoveItem')
        @sendAction( 'onRemoveItem', item )
      else
        @get('content').removeObject( item )

      false

    addItem: (item) ->
      if @get('onAddItem')
        @sendAction( 'onAddItem', item )
      else
        @get('content').addObject( item )

      false

    createItem: (query) ->
      @sendAction('onCreateItem', query )
      false

    loadMore: (query) ->
      @sendAction('onLoadMore', query)
      false


